import React, { useState, useEffect } from 'react';
import axios from 'axios';

const TableSelector = ({base_url}) => {
  const [selectedTable, setSelectedTable] = useState('');
  const [data, setData] = useState([]);
  const tables = ['users', 'question-materials', 'questions', 'exams', 'assignments', 'submissions'];

  useEffect(() => {
    if (selectedTable) {
      fetchData();
    }
  }, [selectedTable]);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${base_url}/${selectedTable}`);
      setData(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleTableChange = (e) => {
    setSelectedTable(e.target.value);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${base_url}/${selectedTable}/${id}`);
      fetchData(); // Refresh the data after deletion
    } catch (error) {
      console.error('Error deleting data:', error);
    }
  };

  return (
    <div className="table-selector bg-white shadow-md rounded-lg p-6 mb-6">
      <h2 className="text-2xl font-bold mb-4">Select Table</h2>
      <select
        value={selectedTable}
        onChange={handleTableChange}
        className="border border-gray-300 p-2 rounded mb-4 w-full"
      >
        <option value="">Select a table</option>
        {tables.map((table) => (
          <option key={table} value={table}>
            {table}
          </option>
        ))}
      </select>
      {selectedTable && (
        <table className="min-w-full bg-white">
          <thead>
            <tr>
              {data.length > 0 && Object.keys(data[0]).map((key) => (
                <th key={key} className="py-2 px-4 border-b border-gray-200">{key}</th>
              ))}
              <th className="py-2 px-4 border-b border-gray-200">Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr key={item.id}>
                {Object.keys(item).map((key) => (
                  <td key={key} className="py-2 px-4 border-b border-gray-200">{item[key]}</td>
                ))}
                <td className="py-2 px-4 border-b border-gray-200">
                  <button
                    className="bg-red-500 text-white px-4 py-2 rounded"
                    onClick={() => handleDelete(item.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default TableSelector;